import { render } from "./SendCode.vue?vue&type=template&id=4d52c17c&scoped=true"
import script from "./SendCode.vue?vue&type=script&lang=js"
export * from "./SendCode.vue?vue&type=script&lang=js"

import "./SendCode.vue?vue&type=style&index=0&id=4d52c17c&lang=scss&scoped=true"

import exportComponent from "/builds/engineering/loans-and-lines/commercial-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d52c17c"]])

export default __exports__